import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
const Header = (param)=>{
    let { title , rightAction  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full max-w-[640px] mx-auto pt-10 px-5",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex justify-between items-center",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h4",
                    className: "text-strong",
                    children: title
                }),
                rightAction
            ]
        })
    });
};
export default Header;
